<div *ngIf="config" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-in fade-in duration-200">
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200 border border-slate-200">
    <div class="p-6">
      <div class="flex items-start space-x-4 mb-4">
        <div class="flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center border-2 border-amber-100 bg-amber-50 text-amber-500" *ngIf="!config.isDestructive">
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div class="flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center border-2 border-red-100 bg-red-50 text-red-500" *ngIf="config.isDestructive">
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div>
           <h3 class="text-lg font-bold text-slate-800">{{ config.title || 'Please Confirm' }}</h3>
           <p class="text-slate-600 text-sm mt-1">{{ config.message }}</p>
        </div>
      </div>
      
      <div class="flex justify-end gap-3 mt-6">
        <button type="button" (click)="onCancel()" 
          class="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition font-medium text-sm">
          {{ config.cancelLabel || 'Cancel' }}
        </button>
        <button type="button" (click)="onConfirm()"
          [ngClass]="config.isDestructive ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500' : 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'"
          class="px-4 py-2 text-white rounded-lg transition font-medium text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2">
          {{ config.confirmLabel || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</div>
